export const telegramUser = {
    telegram_id: 123456789,
    username: 'testuser',
    first_name: 'Test',
    last_name: 'User',
    language_code: 'ru',
    is_premium: false,
    photo_url: 'https://via.placeholder.com/150',
    email: 'test@example.com',
    init_data: undefined,
}
